const config = {
  callUrl: process.env.REACT_APP_API_URL || "http://localhost:3002",
  gameUrl: process.env.REACT_APP_GAME_URL || "http://localhost/game-screen",
  rcSiteKey: process.env.REACT_APP_RC_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
};

console.log(config.callUrl);
module.exports = config;

